import * as runtime from '../runtime';
import { IInitializeServiceOptions } from '../types';
import { IGetConnectionByName, IGetConnectionByNameResponse } from './models';

export class SassService extends runtime.BaseAPI {
	constructor(
		configuration: runtime.Configuration,
		private tenantId: string,
	) {
		super(configuration);
	}

	async getConnectionByNameRaw(
		requestParameters: IGetConnectionByName,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<IGetConnectionByNameResponse>> {
		if (requestParameters.name === null || requestParameters.name === undefined) {
			throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getConnectionByName.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		const response = await this.request(
			{
				path: `/api/v2/connection/name/{name} `.replace(`{${'name'}}`, encodeURIComponent(String(requestParameters.name))),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	async getConnectionByName(
		requestParameters: IGetConnectionByName,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<IGetConnectionByNameResponse> {
		const response = await this.getConnectionByNameRaw(requestParameters, initOverrides);
		return await response.value();
	}
}

export const initializeSAASService = ({ fetchApi, serviceBaseURLs, tenantId }: Required<IInitializeServiceOptions>) => {
	const sassService = new SassService(
		new runtime.Configuration({
			fetchApi,
			basePath: serviceBaseURLs['saas'],
		}),
		tenantId,
	);
	return sassService;
};
